<!-- Base grid -->
<div class="enterprise-grid-bg pointer-events-none fixed inset-0 -z-40"></div>

<!-- Soft blue glow behind hero -->
<div
    class="subtle-glow pointer-events-none fixed left-1/2 top-0 -z-30 h-[900px] w-[1200px] -translate-x-1/2"
></div>

<!-- Floating accent dots ("stars") -->
<div
    class="bg-blue float-slow pointer-events-none fixed left-[5%] top-[15%] -z-20 h-1 w-1 rounded-full opacity-60"
></div>
<div
    class="bg-blue float-medium pointer-events-none fixed right-[8%] top-[22%] -z-20 h-1.5 w-1.5 rounded-full opacity-40"
></div>
<div
    class="bg-blue float-slow pointer-events-none fixed left-[12%] top-[55%] -z-20 h-1 w-1 rounded-full opacity-50"
></div>
<div
    class="bg-blue float-medium pointer-events-none fixed right-[15%] top-[65%] -z-20 h-1 w-1 rounded-full opacity-55"
></div>
<div
    class="bg-blue float-slow pointer-events-none fixed left-[45%] top-[8%] -z-20 h-1 w-1 rounded-full opacity-30"
></div>
<div
    class="bg-blue float-medium pointer-events-none fixed left-[70%] top-[45%] -z-20 h-1.5 w-1.5 rounded-full opacity-45"
></div>
<div
    class="bg-white float-slow pointer-events-none fixed left-[25%] top-[80%] -z-20 h-0.5 w-0.5 rounded-full opacity-40"
></div>
<div
    class="bg-white float-medium pointer-events-none fixed right-[30%] top-[88%] -z-20 h-0.5 w-0.5 rounded-full opacity-30"
></div>
